import { Stack } from "expo-router";

function FindTutorLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="[tutorId]" />
    </Stack>
  );
}

export default FindTutorLayout;
